<script>
  
  import { DataTable } from "carbon-components-svelte";
  import { Pagination } from "paxray-components-svelte";
  import UiMapper from "../components/UIMapper.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import Header from '../../../../lib/components/Header.svelte';

  export let analysisid;

  let partitions = [];

  let pagination = {
    page: 1,
    pageSize: 10,
    totalItems: partitions.length,
    pageSizes: [10, 20, 50, 100],
  };

  async function getWindowPartitions() {
    const res = await fetchWithSession(
      `/api/analysis/getWindowPartitions?analysisid=` + analysisid
    );
    const text = await res.json();
    partitions = text;

    if (res.ok) {
      return text;
    } else {
      throw new Error(text);
    }
  }

  $: {
    getWindowPartitions();
  }

  let partitionlabel = [0];
</script>

<Header section="Preprocessing" breadcrumb="Screenshot" />

<UiMapper partitionlabel={partitionlabel[0]} {analysisid}></UiMapper>

<DataTable
  size="compact"
  headers={[
    { key: "count", value: "Count" },
    { key: "applicationname", value: "Application" },
    { key: "windowtitle", value: "Window Title" },
    { key: "windowwidth", value: "Window Width" },
    { key: "windowheight", value: "Window Height" },
  ]}
  rows={partitions}
  sortable
  radio
  bind:selectedRowIds={partitionlabel}
  pageSize={pagination.pageSize}
  page={pagination.page}
></DataTable>
<Pagination
  dark
  bind:pageSize={pagination.pageSize}
  bind:page={pagination.page}
  totalItems={partitions.length}
  pageSizes={pagination.pageSizes}
/>
